import { get } from '@kit/utils/APIV1.js'

export const home = async(_id) => {
  return get('home')
}